import React from 'react';
import './GradientCard.css';

function GradientCard() {
    return (
        <section className="gradient-card-section">
            <div className='sub-banner-conainter'>
                <div>
                    <h1 className='sub-banner-title'>Tu marca destacando en todos <span className='span-special-sub-banner'>lados</span></h1>
                    <h3 className='sub-banner-p'>Más de 300 compañías globales confían en nosotros</h3>
                    <a
                        href="https://api.whatsapp.com/send/?phone=%2B5213323104081&text&type=phone_number&app_absent=0"
                        style={{ textDecoration: 'none', color: 'black' }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className='boton-sub-banner'>
                            <img src='images/banner/WA_Logo.svg' className='wa-logo' alt='wa' />
                            Cotiza tu proyecto
                        </span>
                    </a>
                </div>

                {/* Aquí va tu card con gradiente */}
                <div className='gradient-container'>
                    <span className="tag">Empieza hoy</span>
                    <h2 className="gradient-title">Hagamos historia hoy.</h2>
                    <p className="gradient-subtitle">Vive la experiencia Moti</p>
                    <button className="cta-btn">
                        <a
                            href="https://api.whatsapp.com/send/?phone=%2B5213323104081&text&type=phone_number&app_absent=0"
                            style={{ textDecoration: 'none', color: 'white' }}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Contacta un ejecutivo
                        </a>
                    </button>
                    <div className="footer-card">
                        <img src="images/banner/avatar.svg" alt="ejecutivo" className="avatar" />
                        <div>
                            <p className="call-text">Agenda una llamada de 15 minutos</p>
                            <span className="link" style={{ color: 'white' }}>
                                <a
                                    href="https://api.whatsapp.com/send/?phone=%2B5213323104081&text&type=phone_number&app_absent=0"
                                    style={{ textDecoration: 'none', color: 'white' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Programa ahora →
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default GradientCard;
